export default function RightLine1() {
  return (
    <span>
      <span className="mr-c6">$</span>
      <span>USD</span>
    </span>
  );
}
